import React from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../../../packages/CustomModal";
import { compassIcon, deploymentUnitIcon } from "../../../assets";
import { setLocalStorageItem } from "../../../utils/session";
import CustomRadioCheck from "../../../common/styles/components/checkboxs/CustomRadioCheck";

import "./SkipDialog.scss";

const SkipDialog = ({ onClose, CIPNeverShowAgain, setCIPNeverShowAgain }) => {
  const { t } = useTranslation();

  const handleNeverShowAgain = () => {
    setCIPNeverShowAgain((prevState) => {
      const newValue = !prevState;
      console.log("triggered never show again", newValue);
      setLocalStorageItem("CIPneverShowAgain", newValue.toString());
      return newValue;
    });
  };

  const heading = <h2 className="skip-heading">{t("skipDialog.heading")}</h2>;

  return (
    <CustomModal
      header={heading}
      confirmBtn={t("skipDialog.okay")}
      onModalClose={onClose}
      width="550px"
    >
      <div className="info-box">
        <span className="info-text">{t("skipDialog.infoText")}</span>

        <div className="info-item">
          <img src={compassIcon} alt="compass-icon" />
          {t("skipDialog.autoIdentification")}
        </div>

        <div className="info-item">
          <img src={deploymentUnitIcon} alt="deployment-unit-icon" />
          {t("skipDialog.cipMethods")}
        </div>

        <CustomRadioCheck
          id="cip-checkbox"
          label={t("skipDialog.neverShowAgain")}
          checked={CIPNeverShowAgain}
          onChange={handleNeverShowAgain}
          className={"skip-dialog-checkbox"}
        />
      </div>
    </CustomModal>
  );
};

export default SkipDialog;
